import { SWReactIcons } from "@similarweb/icons";
import styled from "styled-components";

export const StyledInfoIconWrapper = styled.div`
    cursor: pointer;

    & ${SWReactIcons} {
        height: 14px;
        width: 14px;
        display: flex;
    }
`;
